import React, { Component } from 'react';

import Header from './Components/Header/Header.js';
import PlateSection from './Components/PlateSection/PlateSection.js';
import Footer from './Components/Footer/Footer.js';
import Modal from './Components/Modal/Modal.js';
import axios from './Components/Axios/Axios.js'

import Branch from 'branch-sdk';



class LandingPage extends Component{
    constructor(props) {
        super(props);
        this.modalToggle = this.modalToggle.bind(this);
        this.state = {
            branchData: null,
            branch: null,
            deskTop: false,
            showModal: false,
            phonNumber: null,
            plates: null
        } 
    }


    componentDidMount(){
        let data = this.props.branchData.data_parsed;
        if (data.plateListId) {
            let expectedData = {
                landingPageTitle: data.landingPageTitle,
                landingPageDescription: data.landingPageDescription,
                plateListId: data.plateListId, 
                plateListAuthor: data.referrerName,
                plateListTitle: data.plateListTitle,
                plateListDescription: data.plateListDescription,
                plateListImage: data['$og_image_url'] ? data['$og_image_url'] : `http://res.cloudinary.com/menud/image/upload/platelist_default_share_image.jpg`
            }
            console.log('Expected Data', expectedData);
            this.setState({branchData: expectedData}, this.getPlatelistSummary);
        } else {
            this.setState({ branchData:
                {
                    landingPageTitle: `Don’t compromise. We’re making it easier then ever to eat great food.`,
                    landingPageDescription: `Check out the meals planned to this week’s PlateList.
                            You’ll need to jump into Menud on iOS or Android to get the recipes. And, we built
                            for you a curated grocery list to make life more convenient. Grab a PlateList and
                            never again compromise nutritious, amazing meals for time and stress.`,
                    plateListId: 595,
                    plateListAuthor: `Menūd`,
                    plateListTitle: `The Fall PlateList`,
                    plateListDescription: `Preparing yourself for the best game day yet? Maybe you're ready to have a home cooked meal and relax by the fire? No matter your fall plans, we have the perfect PlateList for you!`,
                    plateListImage: `http://res.cloudinary.com/menud/image/upload/platelist_default_share_image.jpg`
                }
            }, this.getPlatelistSummary);
        }
        //check device
        if (!(/Mobi|Android/i.test(navigator.userAgent))) {
            this.setState({deskTop: true});
        }
    }  

    getPlatelistSummary = () => {
        axios.get(`${this.state.branchData.plateListId}/summary`).then((response)=>{
            console.log('plateList Days', response.data.platelistDays)
            this.setState({
                plates: response.data.platelistDays
            });
        }).catch((err)=>{
            
        });
    }

    modalToggle = () => {
        if(this.state.deskTop === true && this.state.showModal === false){
            this.setState((prevState) => 
            ({ showModal: !prevState.showModal })
            )
        }else{
            this.setState((prevState) => 
            ({ showModal: !prevState.showModal })
            )
        }
    }

    isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
            return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
        },
        any: function() {
            return (this.isMobile.Android() || this.isMobile.BlackBerry() || this.isMobile.iOS() || this.isMobile.Opera() || this.isMobile.Windows());
        }
    }; 

    displayModal = () => {
        if(this.state.deskTop === true && this.state.showModal === true){
            return (
                <Modal toggle={()=>this.modalToggle()}/>
            );
        }
    }
   
    render() {
        if (this.state.branchData !== null) {
            console.log('render the thing', this.state.branchData)
            return (
                <div className='LandingPage'>
    
                    {this.displayModal()}
    
                    <Header title={this.state.branchData.landingPageTitle} description={this.state.branchData.landingPageDescription} image={this.state.branchData.plateListImage}/>
    
                    <PlateSection id={this.state.branchData.plateListId} author={this.state.branchData.plateListAuthor} 
                                title={this.state.branchData.plateListTitle}
                                description={this.state.branchData.plateListDescription}
                                imageUrl={this.state.branchData.plateListImage}
                                deskTop={this.state.deskTop}
                                plates={this.state.plates}
                                modalToggle={() => this.modalToggle()}
                    />
    
                    <Footer deskTop={this.state.deskTop} modalToggle={(e)=> this.modalToggle(e)}/>
                </div>
            );
        } else {
            return (
                <div className='LandingPage'>
                </div>
            )
        }
    }
}

export default LandingPage;


// WEBPACK FOOTER //
// ./src/Containers/LandingPage/LandingPage.js